// css =>
import "../../BaseStructure.css";
import Styled from "./messageBox.module.css";

// type =>
import { MESSAGE_BOX_TYPE } from "./messageBoxType";

// icons =>
import ErrorIcon from "../../Assets/Icons/error.png";
import SuccessIcon from "../../Assets/Icons/success.png";

function MessageBox({ messageType, messageText }: MESSAGE_BOX_TYPE) {
    return (
        <div className={`row ${ Styled.MessageBoxFrame } `}>
            <div className="col-12">
                <span>{ messageText }</span>
                {
                    messageType === "error" ? (
                        <img src={ ErrorIcon } alt="error" />
                    ) : (
                        <img src={ SuccessIcon } alt="success" />
                    )
                }
            </div>

            <div id={ Styled.SpinnerBar } 
                style={{ backgroundColor: messageType == "error" ? "red" : "green" }}
            ></div>
        </div>
    );
}

export default MessageBox;
